import {SLowcodeList, STitle} from 'shj-components'
import {useEffect, useRef, useState} from 'react';
import {fileConfirm} from '@/utils/file'
import {moneyRender} from '@/utils'
import config from './config.ts';
import {addOrEditFn} from './addAndEdit/index';
import {Button, message, Tooltip} from 'antd';
import {actualMoney} from './actualReturnMoney/index';
import {tableApiFunc} from "@/utils/data.ts";
import {
    exportAccountDetail,
    qualityMoneyAccountDetailPage,
} from "@/services/qualityMoneyAccount.ts";
import {useRequest} from "ahooks";
import { getEnums } from '@/services/homeService.ts';

const AccountTable = (props: any) => {
    const listRef = useRef<any>();
    let {
        loading: exportFnStatus,
        runAsync: moneyAccountExportDetail
    } = useRequest(exportAccountDetail, {manual: true});
    const [quaChangeTypeEnum, setQuaChangeTypeEnum] = useState([]);
    const [quaChangeReasonEnum, setQuaChangeReasonEnum] = useState([]);
    // 获取select查询数据
    const getStatusOptions = () => {
        return new Promise(async (resolve, reject) => {
            const quaStatusEnum = await getEnums("plus-pm", "com.shj.saas.plus.pm.domain.qua.enums.QuaStatusEnum")
            const quaChangeReasonEnum: any = await getEnums("plus-pm", "com.shj.saas.plus.pm.domain.qua.enums.QuaChangeReasonEnum")
            const quaChangeTypeEnum:any = await getEnums("plus-pm", "com.shj.saas.plus.pm.domain.qua.enums.QuaChangeTypeEnum")
            setQuaChangeTypeEnum(quaChangeTypeEnum)
            setQuaChangeReasonEnum(quaChangeReasonEnum)
            resolve({
                quaStatusEnum,
                quaChangeTypeEnum,
                quaChangeReasonEnum
            });
        });
    };

    // 新增or编辑
    const onAddOrEdit = async (record: any) => {
        addOrEditFn({
            fn: () => {
                listRef.current.reload();
            },
            ...record,
            quaChangeTypeEnum,
            okCall: () => listRef.current.reload(),
            quaChangeReasonEnum,
            accountId: props?.accountId,
        });
    };

    const openActual = async (record, user) => {
        actualMoney({
            fn: () => {
                listRef.current.reload();
            },
            user,
            accountId: props.accountId,
        });
    };

    const onExport = () => {
        let query = listRef.current?.getSearch?.()?.getFieldsValue?.();
        moneyAccountExportDetail({params: {...query, accountId: props.accountId}}).then(() => {
            fileConfirm()
        })
    }
    const extension = {
        request: {
            fetchList: tableApiFunc(qualityMoneyAccountDetailPage, {
                fieldNames: {current: 'current'},
                data: {accountId: props.accountId}
            }),
            getStatusOptions,
        },
        events: {
            onAddOrEdit,
        },
        status: {
            // btnDisabled: ({ selectedRowKeys }: any) => selectedRowKeys.length <= 0,
        },
        customRender: {
            setAmount(text: any) {
                return <span>{moneyRender(text)}</span>;
            },
            setChangedBalance(text: any) {
                return <span>{moneyRender(text)}</span>;
            },
            setReasonDescribe(text: any, _record: any) {
                return (
                    <Tooltip placement="topLeft" title={text || ''}>
                        <div
                            style={{
                                width: '100px',
                                overflow: 'hidden',
                                whiteSpace: 'nowrap',
                                textOverflow: 'ellipsis',
                            }}
                        >
                            {text || ''}
                        </div>
                    </Tooltip>
                );
            },
            setSourceNumber(text: any) {
                return (
                    <Tooltip placement="topLeft" title={text || ''}>
                        <div
                            style={{
                                width: '100px',
                                overflow: 'hidden',
                                whiteSpace: 'nowrap',
                                textOverflow: 'ellipsis',
                            }}
                        >
                            {text || ''}
                        </div>
                    </Tooltip>
                );
            },
            exportFn() {
                return (
                    <Button onClick={onExport} loading={exportFnStatus}>
                        导出查询结果
                    </Button>
                );
            },
            onActualReturnMoney(_text: any, record: any) {
                return <Button
                size="middle"
                onClick={() => {
                    openActual(record, props.user);
                }}
            >
                退质保金
            </Button>
            }
        },
    };
    return <>
    <STitle title={'质保金明细'} />
    <SLowcodeList searchMode="group" config={config} ref={listRef} {...extension} />
    </>
    
};

export default AccountTable;
